import React from 'react'
import CSS from 'csstype'

import { PRRect } from '@sketch-hq/sketch-web-renderer'
import { Orientation } from './types'
import { useMapPRRectToCanvasRelativeRect } from '../../hooks/inspector'

import { ReactComponent as TopLeft } from '@sketch/icons/inspector/top_left'
import { ReactComponent as TopRight } from '@sketch/icons/inspector/top_right'
import { ReactComponent as BottomLeft } from '@sketch/icons/inspector/bottom_left'
import { ReactComponent as BottomRight } from '@sketch/icons/inspector/bottom_right'

import * as S from './ArtboardDetailInspectorOverlay.styles'
import { OVERLAYS_Z_INDEX } from './constants'

// The corner SVGs are drawn using an outer border which means they are drawn at a 1
// pixel offset.
const CORNER_OFFSET = 1
const SELECTED_LAYER_MIN_SIZE_TO_SHOW_CORNERS = 12

type SelectionGuidelinesProps = {
  bounds: PRRect
}

export function SelectionGuidelines({ bounds }: SelectionGuidelinesProps) {
  const canvasRelativeRect = useMapPRRectToCanvasRelativeRect(bounds)

  if (!canvasRelativeRect) {
    return null
  }

  const { x, y, width, height } = canvasRelativeRect
  const cornerStyles: CSS.Properties = {
    position: 'absolute',
    width: `6px`,
    height: `6px`,
  }

  // Don't show the corners if the selected rectangle is very small
  // as the corner won't fit.
  const showSelectedLayerCorners =
    width >= SELECTED_LAYER_MIN_SIZE_TO_SHOW_CORNERS &&
    height >= SELECTED_LAYER_MIN_SIZE_TO_SHOW_CORNERS

  return (
    <>
      <S.SelectionGuidelines
        $width={width}
        $height={height}
        $x={x}
        $y={y}
        $orientation={Orientation.Horizontal}
      />

      <S.SelectionGuidelines
        $width={width}
        $height={height}
        $x={x}
        $y={y}
        $orientation={Orientation.Vertical}
      />

      <S.LayerOverlay
        $borderSize={1}
        $color="red"
        $width={width}
        $height={height}
        $x={x}
        $y={y}
        $zIndex={OVERLAYS_Z_INDEX.SELECTION_RECTANGLE}
      />
      {showSelectedLayerCorners && (
        <S.SelectedLayerCorners $width={width} $height={height} $x={x} $y={y}>
          <TopLeft
            style={{
              top: -CORNER_OFFSET,
              left: -CORNER_OFFSET,
              ...cornerStyles,
            }}
          />
          <TopRight
            style={{
              top: -CORNER_OFFSET,
              right: -CORNER_OFFSET,
              ...cornerStyles,
            }}
          />
          <BottomLeft
            style={{
              bottom: -CORNER_OFFSET,
              left: -CORNER_OFFSET,
              ...cornerStyles,
            }}
          />
          <BottomRight
            style={{
              bottom: -CORNER_OFFSET,
              right: -CORNER_OFFSET,
              ...cornerStyles,
            }}
          />
        </S.SelectedLayerCorners>
      )}
    </>
  )
}
